import FeaturedSolutions from "../../../components/FeaturedSolutions";
import HorizontalLine from "../../../components/icons/HorizontalLine";
import LogoMini from "../../../components/icons/LogoMini";
import Eatec2 from "../../../assets/img/Featured/tablet-eatec-2.png";
import KDS from "../../../assets/img/Featured/tablet-kitchen-system.png";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useCallback } from "react";
import { useData } from "../../../context/DataProvider";
import { Header } from "../../../components/Header";

const KitchenPage = () => {
    const navigate = useNavigate();
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    return(
        <div className="page kitchenPage">
            <Header />
            <div className="page-header">On Site Dining</div>
            <div className="text-wrapper">
                <div className="top">
                    <div className="topic-header">Kitchen</div>
                    <HorizontalLine />
                </div>
                <div className="std-text">
                    Whether diners place their orders via the POS, a
                    self-service kiosk, their desktop or mobile
                    phones, all orders are routed to the kitchen and
                    managed using the IG Kitchen Display System to
                    ensure quick and accurate order delivery, with
                    Eatec inventory ensuring every ingredient is fresh
                    and on-hand.
                </div>

            </div>

            <FeaturedSolutions>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Dining - Kitchen", "IG KDS");
                    addFlow("IG KDS");
                    navigate("/solutions/ig-kds")}}>
                    <img src={KDS} alt="" />
                    <div className="item-head">
                        <LogoMini />
                        IG KDS
                    </div>
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Dining - Kitchen", "Eatec");
                    addFlow("Eatec");
                    navigate("/solutions/eatec")}}>
                    <img src={Eatec2} alt="" />
                    <div className="item-head">
                        <LogoMini />
                        Eatec
                    </div>
                </div>
            </FeaturedSolutions>
        </div>
    )
}
export default KitchenPage;